module.exports = __webpack_public_path__ + "static/media/disabled-arrow.54faca5d.svg";